export class DisAssistenceEntity{
    id:number;
    monthId:number;
    headCountId:number;
    day:number;

    constructor(){}
}